import { useState } from 'react'

import { useDebounce, usePagination } from '@fourthwall/components'

import { useFilterPosts } from '../../hooks/useFilterPosts'

export const usePostsSearch = () => {
  const [, setCurrentPage] = usePagination()
  const { searchQueryParam, setSearchQueryParam } = useFilterPosts()
  const [value, setValue] = useState(searchQueryParam || '')

  const handleSearch = useDebounce((value: string) => {
    if (value == searchQueryParam) {
      return null
    }

    if (value.length === 0) {
      handleInputClear()
    }

    if (value.length >= 3) {
      setCurrentPage(1)
      setSearchQueryParam(value)
    }
  }, 500)

  const handleInputChange = (value: string) => {
    setValue(value)
    handleSearch(value)
  }

  const handleInputClear = () => {
    setValue('')
    setSearchQueryParam(undefined)
  }

  return {
    value,
    onInputChange: handleInputChange,
    onInputClear: handleInputClear,
  }
}
